export const getClaimLossCause = {
  multi_vehicle: 'Collision with other vehicle(s)',
  single_vehicle: 'Collision with something else',
  weather_events: 'Weather event',
  crime: 'Crime against my vehicle',
  random: 'Random event',
  fire: 'Damage due to fire',
  water: 'Damage due to water',
  windHail: 'Damage due to wind or hail',
  theftMissing: 'Theft or missing item',
  other: 'Something else',
  occupantThirdPartyVehicle: 'Occupant of another vehicle',
  injuredPedestrianOrCyclist: 'Injured as a pedestrian or cyclist',
  default: '-',
};

export const getClaimSecLossCause = {
  otherRearEnded: 'Vehicle I was in was rear-ended by another vehicle',
  iRearEnded: 'Vehicle I was in rear-ended another vehicle',
  otherChangedLanes: 'Another vehicle changed lanes into the vehicle I was in',
  iChangedLanes: 'Vehicle I was in changed lanes into another vehicle',
  otherTurnedLeft: 'Another vehicle turned left in front of the vehicle I was in',
  iTurnedLeft: 'Vehicle I was in turned left in front of another vehicle',
  otherBacked: 'Another vehicle backed into the vehicle I was in',
  iBacked: 'Vehicle I was in backed into another vehicle',
  otherStruckParked: 'Vehicle I was in struck another parked vehicle',
  iStruckParked: 'Vehicle I was in was struck while parked',
  other: 'Other',
  collisionWithAnimal: 'Collision with animal',
  collisionWithPedestrian: 'Collision with pedestrian',
  collisionWithCyclist: 'Collision with cyclist',
  collisionWithObjectGround: 'Collision with object/the ground',
  theft: 'Theft',
  attemptedTheft: 'Attempted theft',
  arsonFire: 'Arson (fire)',
  vandalism: 'Vandalism',
  flyingFallingObjects: 'Flying or falling object',
  explosion: 'explosion',
  wind: 'Wind',
  hail: 'Hail',
  fire: 'Fire',
  lightning: 'Lightning',
  flood: 'flood',
  default: '-',
};
